import { atom } from 'jotai'

export const alternateLanguagesState = atom([])
